import ClassNames from "classnames";
import * as React from "react";
import Styles from "./Radio.module.css";

import InputLabel from "../InputLabel";

export interface Props {
  name: string;
  value: string;
  className?: string;
  label: string;
  id: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  radioTile?: boolean;
  inputRef?: any;
  isRequired?: boolean;
}

const Radio: React.FC<Props> = props => {
  const {
    className,
    label,
    name,
    value,
    id,
    disabled,
    onChange,
    checked,
    radioTile,
    isRequired,
    inputRef
  } = props;

  return (
    <div
      className={ClassNames({
        [Styles.optionWrapper]: true,
        [Styles.radioTile]: radioTile,
        [className]: className
      })}
      role="radiogroup"
    >
      <input
        type="radio"
        className="sr-only"
        name={name}
        value={value}
        id={id}
        disabled={disabled ? disabled : undefined}
        onChange={onChange}
        checked={checked}
        required={isRequired}
        ref={inputRef}
      />
      <span className={Styles.checkmark} />
      <InputLabel label={label} htmlFor={id} className={Styles.optionLabel} />
    </div>
  );
};

export default Radio;
